<template>
  <div>
    <div class="header-bc">
      <div class="content">
        <div class="label clearfix">
          <div class="title">手机号</div>
          <div class="input">
            <input type="text" placeholder="请输入手机号码" v-model="loginData.mobile">
          </div>
        </div>
        <div class="label clearfix mat-10">
          <div class="title">登录密码</div>
          <div class="input">
            <input type="password" placeholder="请输入密码" v-model="loginData.password">
          </div>
        </div>
        <button class="btn-main btn-account" @click="onLogin">登录</button>
        <div class="clearfix hint-message">
          <div class="fl-left">
            <router-link :to="{path:'/account/forgetPassword'}">忘记密码</router-link>
          </div>
          <div class="fl-right">
            <router-link :to="{path:'/account/register'}">还没有账号?</router-link>
          </div>
        </div>
        <wx-login :WeixinLoginApi="WeixinLoginApi"></wx-login>
      </div>
      <router-link :to="{path:'/'}" class="btn-main btn-home">返回首页</router-link>
    </div>
  </div>
</template>

<script>
import wxLogin from '@/components/wxLogin.vue'
export default {
  components: {
    'wx-login': wxLogin
  },
  data() {
    return {
      WeixinLoginApi: '/api/Account/WeixinLogin?returnUrl=',
      loginData: {
        mobile: '',
        password: ''
      }
    }
  },
  methods: {
    onLogin() {
      var url = this.$getUrlKey('returnUrl')
      console.log(this.loginData.mobile)
      if (this.validNull(this.loginData.mobile)) {
        this.$dialog.toast({
          mes: '请输入手机号',
          timeout: 1500
        })
      } else if (!this.isMobile(this.loginData.mobile)) {
        this.$dialog.toast({
          mes: '请输入正确的手机号',
          timeout: 1500
        })
      } else if (this.validNull(this.loginData.password)) {
        this.$dialog.toast({
          mes: '请输入密码',
          timeout: 1500
        })
      } else {
        this.$postUrl('/api/Account/Login', this.loginData)
          .then(result => {
            this.$dialog.toast({
              mes: '登录成功！',
              timeout: 1500
            })
            window.localStorage.setItem('ei_token', result)
            if (url) {
              window.location.href = url
            } else {
              window.location.href = '/'
            }
          })
          .catch(result => {
            this.$dialog.toast({
              mes: result.Error.Message,
              timeout: 2500
            })
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header-bc {
  width: 100%;
  // height: 690 / @rem-size;
  background: url('../../assets/images/account-bc.png');
  background-size: 100% 100%;
  padding-top: 178 / @rem-size;

  .content {
    width: 640 / @rem-size;
    height: auto;
    background: #fff;
    margin: 0 auto;
    border-radius: 8 / @rem-size;
    padding: 52 / @rem-size 30 / @rem-size 100 / @rem-size;
  }

  .label {
    width: 100%;
    height: 89 / @rem-size;

    .title {
      float: left;
      line-height: 89 / @rem-size;
      width: 120 / @rem-size;
      text-align: right;
      font-size: 28 / @rem-size;
      color: #333;
    }

    .input {
      width: 430 / @rem-size;
      height: 89 / @rem-size;
      float: right;
      border-bottom: 1px solid #e5e5e5;

      input {
        width: 100%;
        height: 100%;
        font-size: 28 / @rem-size;
        padding-left: 10 / @rem-size;
      }
    }
  }
}

.mat-10 {
  margin-top: 10 / @rem-size;
}

.btn-account {
  width: 100%;
  height: 80 / @rem-size;
  font-size: 36 / @rem-size;
  border-radius: 8 / @rem-size;
  margin-top: 57 / @rem-size;
}

.hint-message {
  margin-top: 28 / @rem-size;

  div {
    a {
      font-size: 28 / @rem-size;
      color: #999;
    }
  }
}

.btn-home {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  margin: 0 auto;
  margin-top: 40 / @rem-size;
  font-size: 34 / @rem-size;
  color: #fff;
  border-radius: 8 / @rem-size;
  line-height: 80 / @rem-size;
  text-align: center;
}
</style>
